import { render, staticRenderFns } from "./MatchCostDetail.vue?vue&type=template&id=54ee7f51&scoped=true"
import script from "./MatchCostDetail.vue?vue&type=script&lang=js"
export * from "./MatchCostDetail.vue?vue&type=script&lang=js"
import style0 from "./MatchCostDetail.vue?vue&type=style&index=0&id=54ee7f51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ee7f51",
  null
  
)

export default component.exports